// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.audiences_layout__cAb5W {
  display: grid;
  gap: var(--space-6);
  grid-template-columns: minmax(0, 1fr);
}

.audiences_tabs__ze75D {
  display: flex;
  gap: var(--space-2);
  overflow-x: auto;
  padding-bottom: var(--space-2);
  scrollbar-width: none;
}
.audiences_tabs__ze75D::-webkit-scrollbar {
  display: none;
}
.audiences_tab__yDTrX {
  flex: 1 0 auto;
  display: flex;
  align-items: baseline;
  gap: var(--space-3);
  padding: 0.85rem 1.25rem;
  background: transparent;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-pill);
  font-family: var(--font-sans);
  color: var(--color-text-muted);
  cursor: pointer;
  transition: color var(--dur-fast) ease, background var(--dur-fast) ease,
    border-color var(--dur-fast) ease;
}
.audiences_tab__yDTrX:hover {
  color: var(--color-ink);
  border-color: var(--color-ink);
}
.audiences_tab__yDTrX[aria-selected="true"] {
  background: var(--color-ink);
  border-color: var(--color-ink);
  color: #fff;
}
.audiences_num__BR0Ea {
  font-size: var(--text-caption);
  font-variant-numeric: tabular-nums;
  opacity: 0.7;
}
.audiences_tabLabel__CA7bM {
  font-size: 1.15rem;
  font-weight: 500;
}

.audiences_panel__XJ061 {
  min-width: 0;
  background: var(--color-paper);
  border-radius: var(--radius-lg);
  overflow: hidden;
  box-shadow: var(--shadow-sm);
  --accent: var(--kur-gold);
}
.audiences_panel__XJ061[data-audience="physicians"] {
  --accent: var(--kur-amber);
}
.audiences_panel__XJ061[data-audience="patients"] {
  --accent: var(--kur-yellow-soft);
}
.audiences_panelInner__xQxdd {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
}
.audiences_copy__gl1Hw {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-5);
  padding: clamp(1.5rem, 1rem + 2.5vw, 3.5rem);
  border-top: 4px solid var(--accent);
}
.audiences_heading__jgIXa {
  margin: 0;
  font-size: var(--text-h3);
  line-height: var(--leading-heading);
  font-weight: 500;
  letter-spacing: var(--tracking-subheading);
  text-wrap: balance;
}
.audiences_description__yrX0Y {
  margin: 0;
  color: var(--color-text-muted);
  line-height: var(--leading-body);
}
.audiences_benefits__WtO9E {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: var(--space-3);
}
.audiences_benefits__WtO9E li {
  position: relative;
  padding-left: 1.75rem;
  line-height: 1.5;
}
.audiences_benefits__WtO9E li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0.55em;
  width: 0.9rem;
  height: 2px;
  background: var(--accent);
}
.audiences_media__zYWdY {
  order: -1;
  min-height: 14rem;
  max-height: 20rem;
  overflow: hidden;
}
.audiences_media__zYWdY img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 25%;
  display: block;
}

@media (max-width: 991px) {
  .audiences_tab__yDTrX {
    flex: 1 1;
    justify-content: center;
    padding: 0.75rem 0.5rem;
  }
  .audiences_num__BR0Ea {
    display: none;
  }
  .audiences_tabLabel__CA7bM {
    font-size: 1rem;
  }
}

@media (min-width: 992px) {
  .audiences_layout__cAb5W {
    grid-template-columns: 15rem minmax(0, 1fr);
    gap: var(--space-7);
    align-items: start;
  }
  .audiences_tabs__ze75D {
    flex-direction: column;
    gap: 0;
    overflow: visible;
    border-left: 1px solid var(--color-border);
  }
  .audiences_tab__yDTrX {
    border: 0;
    border-radius: 0;
    padding: 1.35rem 0 1.35rem 1.5rem;
    margin-left: -1px;
    border-left: 3px solid transparent;
  }
  .audiences_tab__yDTrX:hover {
    border-color: transparent;
    border-left-color: var(--color-mist);
  }
  .audiences_tab__yDTrX[aria-selected="true"] {
    background: transparent;
    color: var(--color-ink);
    border-left-color: var(--kur-gold);
  }
  .audiences_tab__yDTrX[aria-selected="true"] .audiences_tabLabel__CA7bM {
    font-size: 1.6rem;
  }
  .audiences_panelInner__xQxdd {
    grid-template-columns: minmax(0, 1.05fr) minmax(0, 0.95fr);
    min-height: 32rem;
  }
  .audiences_copy__gl1Hw {
    border-top: 0;
    border-left: 4px solid var(--accent);
    justify-content: center;
  }
  .audiences_media__zYWdY {
    order: 0;
    min-height: 100%;
    max-height: none;
    border-radius: 45% 0 0 45% / 50% 0 0 50%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/HOME_PAGE/SECTIONS/AUDIENCES/audiences.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,wBAAwB;EACxB,uBAAuB;EACvB,qCAAqC;EACrC,iCAAiC;EACjC,6BAA6B;EAC7B,8BAA8B;EAC9B,eAAe;EACf;qCACmC;AACrC;AACA;EACE,uBAAuB;EACvB,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,4CAA4C;EAC5C,mCAAmC;AACrC;AACA;EACE,SAAS;EACT,yBAAyB;EACzB,mCAAmC;EACnC,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,8BAA8B;EAC9B,gCAAgC;AAClC;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,aAAa;EACb,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE;IACE,SAAW;IACX,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,2CAA2C;IAC3C,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,MAAM;IACN,iBAAiB;IACjB,0CAA0C;EAC5C;EACA;IACE,SAAS;IACT,gBAAgB;IAChB,iCAAiC;IACjC,iBAAiB;IACjB,kCAAkC;EACpC;EACA;IACE,yBAAyB;IACzB,oCAAoC;EACtC;EACA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,kCAAkC;EACpC;EACA;IACE,iBAAiB;EACnB;EACA;IACE,0DAA0D;IAC1D,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,oCAAoC;IACpC,uBAAuB;EACzB;EACA;IACE,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;IAChB,wCAAwC;EAC1C;AACF","sourcesContent":[".layout {\n  display: grid;\n  gap: var(--space-6);\n  grid-template-columns: minmax(0, 1fr);\n}\n\n.tabs {\n  display: flex;\n  gap: var(--space-2);\n  overflow-x: auto;\n  padding-bottom: var(--space-2);\n  scrollbar-width: none;\n}\n.tabs::-webkit-scrollbar {\n  display: none;\n}\n.tab {\n  flex: 1 0 auto;\n  display: flex;\n  align-items: baseline;\n  gap: var(--space-3);\n  padding: 0.85rem 1.25rem;\n  background: transparent;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-pill);\n  font-family: var(--font-sans);\n  color: var(--color-text-muted);\n  cursor: pointer;\n  transition: color var(--dur-fast) ease, background var(--dur-fast) ease,\n    border-color var(--dur-fast) ease;\n}\n.tab:hover {\n  color: var(--color-ink);\n  border-color: var(--color-ink);\n}\n.tab[aria-selected=\"true\"] {\n  background: var(--color-ink);\n  border-color: var(--color-ink);\n  color: #fff;\n}\n.num {\n  font-size: var(--text-caption);\n  font-variant-numeric: tabular-nums;\n  opacity: 0.7;\n}\n.tabLabel {\n  font-size: 1.15rem;\n  font-weight: 500;\n}\n\n.panel {\n  min-width: 0;\n  background: var(--color-paper);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  box-shadow: var(--shadow-sm);\n  --accent: var(--kur-gold);\n}\n.panel[data-audience=\"physicians\"] {\n  --accent: var(--kur-amber);\n}\n.panel[data-audience=\"patients\"] {\n  --accent: var(--kur-yellow-soft);\n}\n.panelInner {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n}\n.copy {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: var(--space-5);\n  padding: clamp(1.5rem, 1rem + 2.5vw, 3.5rem);\n  border-top: 4px solid var(--accent);\n}\n.heading {\n  margin: 0;\n  font-size: var(--text-h3);\n  line-height: var(--leading-heading);\n  font-weight: 500;\n  letter-spacing: var(--tracking-subheading);\n  text-wrap: balance;\n}\n.description {\n  margin: 0;\n  color: var(--color-text-muted);\n  line-height: var(--leading-body);\n}\n.benefits {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: grid;\n  gap: var(--space-3);\n}\n.benefits li {\n  position: relative;\n  padding-left: 1.75rem;\n  line-height: 1.5;\n}\n.benefits li::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0.55em;\n  width: 0.9rem;\n  height: 2px;\n  background: var(--accent);\n}\n.media {\n  order: -1;\n  min-height: 14rem;\n  max-height: 20rem;\n  overflow: hidden;\n}\n.media img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center 25%;\n  display: block;\n}\n\n@media (max-width: 991px) {\n  .tab {\n    flex: 1 1 0;\n    justify-content: center;\n    padding: 0.75rem 0.5rem;\n  }\n  .num {\n    display: none;\n  }\n  .tabLabel {\n    font-size: 1rem;\n  }\n}\n\n@media (min-width: 992px) {\n  .layout {\n    grid-template-columns: 15rem minmax(0, 1fr);\n    gap: var(--space-7);\n    align-items: start;\n  }\n  .tabs {\n    flex-direction: column;\n    gap: 0;\n    overflow: visible;\n    border-left: 1px solid var(--color-border);\n  }\n  .tab {\n    border: 0;\n    border-radius: 0;\n    padding: 1.35rem 0 1.35rem 1.5rem;\n    margin-left: -1px;\n    border-left: 3px solid transparent;\n  }\n  .tab:hover {\n    border-color: transparent;\n    border-left-color: var(--color-mist);\n  }\n  .tab[aria-selected=\"true\"] {\n    background: transparent;\n    color: var(--color-ink);\n    border-left-color: var(--kur-gold);\n  }\n  .tab[aria-selected=\"true\"] .tabLabel {\n    font-size: 1.6rem;\n  }\n  .panelInner {\n    grid-template-columns: minmax(0, 1.05fr) minmax(0, 0.95fr);\n    min-height: 32rem;\n  }\n  .copy {\n    border-top: 0;\n    border-left: 4px solid var(--accent);\n    justify-content: center;\n  }\n  .media {\n    order: 0;\n    min-height: 100%;\n    max-height: none;\n    border-radius: 45% 0 0 45% / 50% 0 0 50%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": `audiences_layout__cAb5W`,
	"tabs": `audiences_tabs__ze75D`,
	"tab": `audiences_tab__yDTrX`,
	"num": `audiences_num__BR0Ea`,
	"tabLabel": `audiences_tabLabel__CA7bM`,
	"panel": `audiences_panel__XJ061`,
	"panelInner": `audiences_panelInner__xQxdd`,
	"copy": `audiences_copy__gl1Hw`,
	"heading": `audiences_heading__jgIXa`,
	"description": `audiences_description__yrX0Y`,
	"benefits": `audiences_benefits__WtO9E`,
	"media": `audiences_media__zYWdY`
};
export default ___CSS_LOADER_EXPORT___;
